export default {
  fieldData: [],
  modalFieldData: [],
  plantingOnly: true,
  fieldSearchStatus: 0,
  fieldSearchVariety: '',
  fieldSearchGrade: '',
  fieldSearchRisk: 0,
  fieldSearchText: '',
  fieldListSort: []
}
